import "./GratuityView.scss";

import React from "react";
import { Link } from "react-router-dom";
import request from "request"
import usesFeatures from "usesFeatures"

import Header from "Header"
import Switch from "Switch"
import DeleteButton from "DeleteButton"
import DisplayField from "DisplayField"

class GratuityView extends React.Component {
  constructor (props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    const id = this.props.computedMatch.params.gratuityId
    this.props.fetchData(`venue_admin/gratuities/${id}`)
  }

  refetch = () => this.props.fetchData(`venue_admin/gratuities/${this.props.gratuity.id}`)

  toggleGratuity = (gratuityId) => {
    request.post(`venue_admin/gratuities/${gratuityId}/toggle`).then(this.refetch)
  }

  handleQuickToggle = (storeId) => {
    request.post("venue_admin/gratuities/quick_toggle", {
      store_id: storeId,
      gratuity_id: this.props.gratuity.id,
    }).then(this.refetch)
  }

  amountLabel = (gratuity) =>
    gratuity.gratuityUnit === "percent" ? `${gratuity.gratuityAmount}%` : `$${gratuity.gratuityAmount}`

  render() {
    if (!this.props.dataFetched) return false

    const { gratuity, stores } = this.props
    return(
      <div className="GratuityView">
        <Header text="Gratuities" backLink="/gratuities" actions={true}>
          <Link to={`/gratuities/${gratuity.id}/edit`} className="button is-primary">Edit Gratuity</Link>
          <DeleteButton model="Gratuity" id={gratuity.id} endpoint="gratuities" />
        </Header>

        <div className="s-card mb-4">
          <div className="columns">
            <div className="column is-2">
              <Switch onChange={this.toggleGratuity.bind(null, gratuity.id)} value={gratuity.active} label="Gratuity Status" />
            </div>
            <div className="column is-10">
              <h3 className="title">{ gratuity.name }</h3>

              <DisplayField label="Gratuity Unit" value={ gratuity.gratuityUnit } />
              <DisplayField label="Amount" value={ this.amountLabel(gratuity) } />
              <DisplayField label="Taxable" value={ gratuity.taxable ? "Yes" : "No" } />
              <DisplayField label="Applies automatically" value={ gratuity.autoApply ? "Yes" : "No" } />
              { gratuity.autoApply &&
                <DisplayField
                  label="Auto-apply threshold"
                  value={`$${((gratuity.autoApplyThresholdCents || 0) / 100).toFixed(2)}`}
                />
              }
            </div>
          </div>
        </div>

        <div className="s-card mb-4">
          <h3 className="title">Stores</h3>
          <p className="has-text-grey mb-4">
            Stores where this gratuity can be selected manually on a terminal.
          </p>
          { stores.map((store) => (
            <div key={store.id} className="columns">
              <div className="column">{store.name}</div>
              <div className="column is-narrow">
                { gratuity.storeIds.includes(store.id) ? (
                  <span onClick={this.handleQuickToggle.bind(null, store.id)} className="button is-danger">Remove Gratuity</span>
                ) : (
                  <span onClick={this.handleQuickToggle.bind(null, store.id)} className="button is-success">Add Gratuity</span>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    )
  }
}

export default usesFeatures(["data"], GratuityView)
